<ng-container *ngIf="model" [class.clickable]="isClickable">
  <entity-icon class="icon undraggable" [model]="model.icon" [size]="isOneLine ? '20px' : '24px'"></entity-icon>
  <result-title
    [model]="{ text: model.title, onClick: model.command }"
    [selected]="selected"
    [isClickable]="true"
    (invoke)="onInvoke($event)"
    [highlights]="model.highlights"
  ></result-title>
  <u-icon class="inline-icon" *ngIf="model?.inlineIcon" [model]="model.inlineIcon" [styles]="{ width: '12px', height: '12px' }"></u-icon>
</ng-container>
